<template>
  <v-container fluid fill-height align-center text-xs-center>
    <v-layout>
      <!--- Loading --->
      <v-flex v-if="loading" xs12>
        <v-progress-circular indeterminate color="primary" />
      </v-flex>
      <v-flex v-else xs12>
        <v-card>
          <h2>{{ strings[idioma]["pagamento"].planos_disponiveis }}</h2>
          <v-divider />
          <v-card>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex v-for="plano in Planos" :key="plano.id" lg4 xs12>
                  <v-card>
                    <v-img
                      style="background: gray"
                      height="200px"
                      @click="sejaPremium(plano)"
                    >
                      <span class="headline white--text">
                        {{ plano.titulo }}
                      </span>
                      <hr />
                      <span class="subheading white--text">
                        {{ plano.periodicidade }}
                      </span>
                      <hr />
                      <span class="subheading white--text">
                        {{ plano.moeda
                        }}{{
                          plano.valor
                            .toFixed(2)
                            .replace(".", strings[idioma].separador_float)
                        }}
                      </span>
                      <hr />

                      <span
                        v-if="
                          plano.permite_parcelamento == 1 &&
                          plano.parcelamento_maximo > 1
                        "
                        class="subheading white--text"
                      >
                        Em até {{ plano.parcelamento_maximo }} x de
                        {{ plano.moeda
                        }}{{
                          parseFloat(plano.valor / 4)
                            .toFixed(2)
                            .replace(".", strings[idioma].separador_float)
                        }}
                      </span>
                      <h3 class="subheading white--text">
                        {{ plano.moeda
                        }}{{
                          plano.valorComDesconto
                            .toFixed(2)
                            .replace(".", strings[idioma].separador_float)
                        }}
                        à vista no PIX
                      </h3>
                    </v-img>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
export default {
  data: () => ({
    planos: [],
    loading: false,
  }),
  computed: {
    ...mapState("app", ["idioma", "strings", "user", "empresa", "acesso"]),
    Planos() {
      return this.planos ? this.planos.data : [];
    },
  },
  created() {
    this.getPlanos();
  },
  methods: {
    getPlanos() {
      this.loading = true;
      this.axios
        .post("planos/getPlanos")
        .then((response) => {
          this.planos = response.data.data;
          console.log("planos", this.planos);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    sejaPremium(plano) {
      window.location.href = `${this.axios.defaults.baseURL}pagamento/${btoa(
        this.user.id
      )}/${btoa(plano.codigo)}?ref=${window.location.href}`;
    },
  },
};
</script>
